export default __webpack_public_path__ + "985be84f026b70dd1553250e5603a058.png";